/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Run_EnhanceInputs */

const cs_property_ai_run_enhance = /** @type {(inputs: Property_Ai_Run_EnhanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustit vylepšení`)
};

const en_property_ai_run_enhance = /** @type {(inputs: Property_Ai_Run_EnhanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run enhancement`)
};

/**
* | output |
* | --- |
* | "Run enhancement" |
*
* @param {Property_Ai_Run_EnhanceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_run_enhance = /** @type {((inputs?: Property_Ai_Run_EnhanceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Run_EnhanceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_run_enhance(inputs)
	return cs_property_ai_run_enhance(inputs)
});